module.exports = __webpack_public_path__ + "static/img/sm_7.97e0681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_7.png
// module id = J8UY
// module chunks = 0